const home = {
	overview_cards: {
		dadup: {
			go_to: "Zur daDup-Übersicht",
			title: "daDup",
		},
		domain: {
			go_to: "Zur Domain-Übersicht",
			title: "Domain",
		},
		pbs: {
			go_to: "Zur PBS-Übersicht",
			title: "Tuxis PBS",
		},
		vps: {
			go_to: "Zur VPS-Übersicht",
			title: "VPSs",
		},
	},
	welcome: "Willkommen",
};

export default home;
